import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { CardMenu } from '@/components/ui/card';
    import { columns } from '@/tables/columns/company-groups';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateCompanyGroup from '@/components/company-groups/CreateCompanyGroup.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem, NavItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyGroups',
  setup(__props) {

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'company-affiliation.navbar_header',
            href: route('v2.companies.index'),
        },
    ];

    const navItems: NavItem[] = [
        {
            title: 'companies.header',
            href: route('v2.companies.index'),
            permissionLevel: Permission.USERS_VIEW,
        },
        {
            title: 'company-affiliation.navbar_header',
            href: route('v2.company-groups.index'),
            permissionLevel: Permission.USERS_VIEW,
        },
    ];

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.COMPANY_GROUPS],
        queryFn: getCompanyGroups,
    });

    async function getCompanyGroups() {
        const { data } = await axios.get(route('v2.company-groups.table'));
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('profile.profile_settings')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).COMPANY_GROUPS,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending)
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardMenu), { items: navItems })
              ]),
              actions: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "company-groups" }, {
                  default: _withCtx(() => [
                    (_unref(hasPermission)(_unref(Permission).COMPANIES_CREATE))
                      ? (_openBlock(), _createBlock(CreateCompanyGroup, { key: 0 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})